import React from "react";
import Header from "@/components/jp/Header";
import Menu from "@/components/jp/Menu";
import Footer from "@/components/jp/Footer";
import FloatingButton from "@/components/jp/FloatingButton";
import ScrollToTopFab from "@/components/jp/ScrollToTopFab";
import Link from "next/link";
import Image from "next/image";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CircleIcon from "@mui/icons-material/Circle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Stack from "@mui/material/Stack";
import SAbout from "@/public/static/images/opacity_about.png";
import SPorcess from "@/public/static/images/opacity_process.png";
import SInstru from "@/public/static/images/opacity_instru.png";

import Env1 from "@/public/static/images/instrument/env-1.png";
import { monthConvertDMY } from "@/features/monthConvert";

function NewsDetail({ data }: any) {
  const breadcrumbs = [
    <Link key="1" href="/">
      ホーム
    </Link>,
    <Link key="2" href="/news">
      ニュース
    </Link>,
    <Typography key="3">{data.topic}</Typography>,
  ];

  return (
    <div className="wrapper">
      <Header />
      <Menu />
      <div className="coverMain">
        <div className="container">
          <div className="row">
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  noWrap
                  sx={{
                    mr: 2,
                    mb: 1,
                    fontFamily: "Titillium Web",
                    fontWeight: 800,
                    letterSpacing: ".1rem",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <CircleIcon
                    sx={{ mb: 1, mr: 2, fontSize: "18px", color: "#0179CC" }}
                  />
                  ニュース
                </Typography>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                  className="breadcrumbs"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>

      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-3">
              <div className="subject-news">
                <h5>{`${data.topic}`}</h5>
                <p>
                  <CalendarMonthIcon
                    sx={{ fontSize: "14px", mb: 0.5, mr: 1 }}
                  />
                  {monthConvertDMY(data.post_date)}
                </p>
              </div>
            </div>
            <div className="col-12 mb-4">
              <div className="content-news_inner">
                <span dangerouslySetInnerHTML={{ __html: data.detail }}></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="sub-contact mt-5">
        <div className="sub-contact-inner">
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 0, sm: 0, md: 0 }}
            justifyContent="center"
            alignItems="center"
          >
            <Link href="/processusage">
              <div className="card card-subcontact bg-darkblue">
                <Image
                  loading="lazy"
                  src={SPorcess}
                  alt="Process & Usage"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">加工・用途紹介</h1>
                </div>
              </div>
            </Link>
            <Link href="/instrument">
              <div className="card card-subcontact bg-blue">
                <Image
                  loading="lazy"
                  src={SInstru}
                  alt="Instrument Overview"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">設備概要</h1>
                </div>
              </div>
            </Link>
            <Link href="/aboutus">
              <div className="card card-subcontact bg-darkblue">
                <Image
                  loading="lazy"
                  src={SAbout}
                  alt="About Us"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">会社概要</h1>
                </div>
              </div>
            </Link>
          </Stack>
        </div>
      </section>
      <FloatingButton />
      <ScrollToTopFab />
      <Footer />
    </div>
  );
}
export async function getServerSideProps(context: any) {
  const id = context.params.id;
  const url = process.env.NEXT_PUBLIC_BASE_URL_API;
  const fetchNews = await fetch(`${url}/v1/news/show?id=${id}`);
  const news = await fetchNews.json();

  return {
    props: {
      data: news.data[0],
    },
  };
}
export default NewsDetail;
